// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/common.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._918c14{color:var(--secondary);background:radial-gradient(closest-side, var(--background) 10%, transparent);padding:3em}.c1ec7a{position:absolute;left:0;right:0;height:.5em;cursor:ns-resize}.c9391a{top:0}._5eee67{bottom:0}.a5513c .c1ec7a{height:4px}.a5513c ._1634ed{padding:.1em .5em}.a5513c ._792b08{top:.1em}._92c63c[aria-expanded=true] svg{color:#fff;background:var(--primary);box-shadow:0 0 0 .125em var(--primary)}", ""]);
// Exports
exports.locals = {
	"duration": "_918c14 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["in-center"] + "",
	"resize-handle": "c1ec7a",
	"resizeHandle": "c1ec7a",
	"top-handle": "c9391a c1ec7a",
	"topHandle": "c9391a c1ec7a",
	"bottom-handle": "_5eee67 c1ec7a",
	"bottomHandle": "_5eee67 c1ec7a",
	"isSmall": "a5513c",
	"body": "_1634ed",
	"checkbox": "_792b08",
	"toolbar": "_92c63c"
};
module.exports = exports;
